import React, {useState, useEffect} from "react";
import { Outlet } from "react-router-dom";
import "../styles/app.scss";
import { useSelector } from "react-redux";
import { selectAdminUuid, selectAccessToken } from "../features/auth/authSlice";
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getRoleJSON } from "./utils"; 
import { logout } from '../features/auth/authSlice';

export default function Root() {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const thisUUID = useSelector(selectAdminUuid);
  const accessToken = useSelector(selectAccessToken);

  const [roleJSON, setRoleJSON] = useState({isAdmin: false, isCS: false, isLegal: false, isCSAdmin:false});

  const assignRoleJSON = async(thisUUID) => {
    if (thisUUID) {
      const roleData = await getRoleJSON(thisUUID);
      setRoleJSON(roleData);
    }
  }
  useEffect(() => {
    if (thisUUID){
      assignRoleJSON(thisUUID);
    }
    
  },[thisUUID]);

  useEffect(() => {
    if (roleJSON){
      const allowedRoutes = ['/expired_docs', '/alltheyearsKYB','/dac7approval','/login', '/ky/launch', '/ky/test', '/ky/test-approve', '/ky/review', 'influencer/contract', '/adbuy'];
      const isAllowedRoute = allowedRoutes.some(route => location.pathname.includes(route));
      
      // The base index route is a public page, so never bounce users off it.
      if ((roleJSON.isCS || roleJSON.isLegal) && location.pathname !== '/' && !location.pathname.includes('/cs/') && !isAllowedRoute) {
        navigate('/cs');
      }
    }
  }, [roleJSON]);

  const isKYBForm = () => {
    return location.pathname.includes('/alltheyearsKYB');
  }

  useEffect(() => {
    if (accessToken) {
      try {
        const tokenData = JSON.parse(atob(accessToken.split('.')[1]));
        const expirationTime = tokenData.exp * 1000;
       
        if (Date.now() >= expirationTime) {
          dispatch(logout());
        } else {
          const timeoutId = setTimeout(function(){console.log('logging out due to timeout');dispatch(logout());}, expirationTime - Date.now());
          return () => clearTimeout(timeoutId);
        }
      } catch (error) {
        dispatch(logout());
      }
    }
  },[accessToken]);

  /*
  const Header = () => (
    <header className={`top-header ${isSidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
      <div className="container-fluid h-100">
        <div className="row h-100 align-items-center">
          <div className="col">
          </div>
          <div className="col-auto">
            <div className="d-flex align-items-center gap-3">
              <div className="position-relative">
              </div>
              <div className="rounded-circle bg-secondary" style={{ width: '2rem', height: '2rem' }}></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
  */

  const toggleMenu = (menuLabel) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuLabel]: !prev[menuLabel]
    }));
  };

  const sendMenuClick = (label) => {
    switch (label){
      case 'Dashboard':
        navigate('/dashboard');
        break;
      case 'Admin Panel':
        navigate('/admin');
        break;
      case 'Cron':
        navigate('/cron');
        break;
      case 'Expired Docs':
        navigate('/expired_docs');
        break;
      case 'Payments Config':
        navigate('/payments-config');
        break;
      case 'Status List':
        navigate('/status');
        break;
      default:  
        navigate('/dashboard');
        break;
    }
  }
  
  const menuStructure = [
    {
      label: 'Activity',
      icon: 'activity',
      submenu: [
        { ADMIN: true, icon: 'person-check', label: 'New Business', path: '/status' },
        { ADMIN: true, icon: 'shield-check', label: 'Compliance', path: '/expired_docs' },
      ]
    },
    {
      label: 'Configuration',
      icon: 'gear',
      submenu: [
        { CSAdmin: true, icon: 'coin', label: 'Payments Config', path: '/payments-config' },
        { ADMIN: true, icon: 'sliders', label: 'Admin Panel', path: '/admin' },
        { ADMIN: true, icon: 'speedometer', label: 'Cron', path: '/cron' },
      ]
    },
  ];

  const hasAccess = (item) => {
    if (roleJSON.isAdmin) return true;
    
    if (item.CS && roleJSON.isCS) return true;
    if (item.Legal && roleJSON.isLegal) return true;
    if (item.CSAdmin && roleJSON.isCSAdmin) return true;
    
    return false;
  };

  const isSubmenuActive = (submenu) => {
    if (!submenu) return false;
    return submenu.some(item => hasAccess(item) && location.pathname.includes(item.path));
  };

  const Sidebar = () => (
    <nav className={`sidebar ${isSidebarExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="sidebar-header d-flex justify-content-between align-items-center p-3">
        {isSidebarExpanded && <h5 className="mb-0">Alltheyears Admin</h5>}
        <button className="btn btn-link p-0" onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}>
          <i className="bi bi-list"></i>
        </button>
      </div>
      <div className="sidebar-menu-wrapper">
        <ul className="nav flex-column">
          {menuStructure.map((menuGroup, groupIndex) => {
          const hasGroupAccess = menuGroup.submenu 
            ? menuGroup.submenu.some(item => hasAccess(item))
            : hasAccess(menuGroup);

          if (!hasGroupAccess) return null;

          if (!menuGroup.submenu) {
            const isActive = location.pathname.includes(menuGroup.path);
            return (
              <li key={groupIndex} className="nav-item">
                <a 
                  className={`nav-link ${isActive ? 'active' : ''}`} 
                  href="#" 
                  onClick={(e) => {e.preventDefault(); sendMenuClick(menuGroup.label)}}
                >
                  <i className={`bi bi-${menuGroup.icon} me-2`}></i>
                  {isSidebarExpanded && <span>{menuGroup.label}</span>}
                </a>
              </li>
            );
          }

          const isExpanded = expandedMenus[menuGroup.label];
          const hasActiveChild = isSubmenuActive(menuGroup.submenu);

          return (
            <li key={groupIndex} className="nav-item">
              <a 
                className={`nav-link nav-link-group ${hasActiveChild ? 'has-active-child' : ''}`} 
                href="#" 
                onClick={(e) => {e.preventDefault(); toggleMenu(menuGroup.label)}}
              >
                <i className={`bi bi-${menuGroup.icon} me-2`}></i>
                {isSidebarExpanded && (
                  <>
                    <span>{menuGroup.label}</span>
                    <i className={`bi bi-chevron-${isExpanded ? 'down' : 'right'} ms-auto submenu-toggle`}></i>
                  </>
                )}
              </a>
              {isSidebarExpanded && isExpanded && (
                <ul className="nav flex-column submenu">
                  {menuGroup.submenu.map((subItem, subIndex) => {
                    if (!hasAccess(subItem)) return null;
                    const isActive = location.pathname.includes(subItem.path);
                    return (
                      <li key={subIndex} className="nav-item">
                        <a 
                          className={`nav-link ${isActive ? 'active' : ''}`} 
                          href="#" 
                          onClick={(e) => {e.preventDefault(); sendMenuClick(subItem.label)}}
                        >
                          <i className={`bi bi-${subItem.icon} me-2`}></i>
                          <span>{subItem.label}</span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
          })}
        </ul>
      </div>
      <div className="sidebar-footer">
        <a className="nav-link" href="#" onClick={(e)=>{e.preventDefault(); dispatch(logout())}}>
          <i className="bi bi-box-arrow-right me-2"></i>
          {isSidebarExpanded && <span>Logout</span>}
        </a>
        {isSidebarExpanded && <p className='rightside small mb-0'>v3.3</p>}
      </div>
    </nav>
  );


  if (useSelector(selectAdminUuid)) { //Logged In
    return (
      <div style={{ minHeight: '100vh' }}>
        {!isKYBForm() && <Sidebar />}
      
        <main className={`main-content ${isKYBForm() ? 'full-page' : isSidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'} `}>
          <Outlet />
        </main>
      </div>

    )
  }
  else { // Not logged in 
    return (
      <div>
        <Outlet />
      </div>
    );
  }
}
